var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyridesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.535,
    height: 26.535,
    viewBox: "0 0 26.535 26.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "car-svgrepo-com",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5269",
    "data-name": "Path 5269",
    d: "M343.882,283.974a2.41,2.41,0,0,0,0,4.817h.006a2.41,2.41,0,0,0-.01-4.817Zm.007,3.709h0a1.3,1.3,0,1,1,1.227-1.3A1.266,1.266,0,0,1,343.886,287.683Z",
    transform: "translate(-326.264 -269.85)",
    fill: "#ff2b01",
    stroke: "#ff2b01",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5270",
    "data-name": "Path 5270",
    d: "M64.027,284.646a2.41,2.41,0,0,0,0,4.817h.006a2.41,2.41,0,0,0-.01-4.817Zm.007,3.709h0a1.3,1.3,0,1,1,1.227-1.3A1.266,1.266,0,0,1,64.031,288.355Z",
    transform: "translate(-55.622 -270.522)",
    fill: "#ff2b01",
    stroke: "#ff2b01",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9605",
    "data-name": "Rectangle 9605",
    width: 1.108,
    height: 4.547,
    transform: "translate(15.29 11.91) rotate(90)",
    fill: "#ff2b01",
    stroke: "#ff2b01",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5271",
    "data-name": "Path 5271",
    d: "M23.483,3.469H21.471l-.149-1.163A2.566,2.566,0,0,0,18.849,0H7.243A2.567,2.567,0,0,0,4.77,2.306L4.621,3.469H2.553A2.649,2.649,0,0,0,0,6.2v.813a2.649,2.649,0,0,0,2.553,2.73h.722L2.454,12a13.88,13.88,0,0,0-.831,4.781l0,1.819a3.619,3.619,0,0,0,.944,2.459,3.156,3.156,0,0,0,1.913,1.01v2.167a1.749,1.749,0,0,0,1.695,1.8H8.266a1.749,1.749,0,0,0,1.695-1.8V22.087l6.171-.015v2.167a1.749,1.749,0,0,0,1.695,1.8h2.088a1.749,1.749,0,0,0,1.695-1.8V22.033a3.433,3.433,0,0,0,2.861-3.484l0-1.819a13.875,13.875,0,0,0-.851-4.777L22.8,9.742h.68a2.649,2.649,0,0,0,2.553-2.73V6.2A2.649,2.649,0,0,0,23.483,3.469ZM5.357,6.445l.512-4A1.46,1.46,0,0,1,7.243,1.108H18.849a1.459,1.459,0,0,1,1.374,1.339l.512,4a1.673,1.673,0,0,1-.388,1.319,1.307,1.307,0,0,1-.986.463H6.731a1.306,1.306,0,0,1-.986-.463A1.672,1.672,0,0,1,5.357,6.445Zm-2.8,2.189A1.543,1.543,0,0,1,1.108,7.012V6.2A1.543,1.543,0,0,1,2.553,4.577H4.48L4.259,6.3a2.86,2.86,0,0,0,0,.763l-.016-.006L3.676,8.634Zm6.3,15.605a.644.644,0,0,1-.587.688H6.178a.644.644,0,0,1-.587-.688V22.1l3.262-.008Zm11.062.688H17.826a.644.644,0,0,1-.587-.688V22.07l3.262-.008v2.177A.644.644,0,0,1,19.915,24.927Zm3.448-6.377a2.29,2.29,0,0,1-2.151,2.4l-16.318.039h0a2.037,2.037,0,0,1-1.5-.682A2.514,2.514,0,0,1,2.734,18.6l0-1.819a12.778,12.778,0,0,1,.765-4.4L4.908,8.488l.006.008a2.4,2.4,0,0,0,1.817.839h12.63a2.4,2.4,0,0,0,1.808-.828l1.407,3.828a12.771,12.771,0,0,1,.783,4.4ZM24.927,7.012a1.543,1.543,0,0,1-1.445,1.622H22.4l-.569-1.549a2.863,2.863,0,0,0,.008-.781l-.221-1.728h1.87A1.543,1.543,0,0,1,24.927,6.2v.813Z",
    fill: "#ff2b01",
    stroke: "#ff2b01",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyridesIcon);
export default __webpack_public_path__ + "static/media/myrides_icon.c32efdbd9e0e8dcda0a6be446b632bdb.svg";
export { ForwardRef as ReactComponent };